import styled from "styled-components";
import {Descriptions, Row, Space} from "antd";

export const Img = styled.img`
    height: 80px;
    display: flex;
    margin: auto;
    border-radius: 4px;
    border: 10px solid #fafafa;
    box-sizing: content-box;
`;
export const MarkerImg = styled.img`
    width: 25px;
    height: 30.125px;
    display: flex;
    margin: auto;
`;
export const OrderMergeContainer = styled(Descriptions)`
    margin-top: 40px;
    margin-bottom: 20px;
`;
export const CityContainer = styled.div`
    min-width: 235px;
    @media (max-width: 768px) {
        min-width: 100%;
    }
`;
export const ResponsiveDescriptions = styled.div`
    @media (max-width: 768px) {
        .ant-descriptions-view {
            overflow-x: hidden;
        }
        .ant-descriptions-view table {
            display: block;
        }
        .ant-descriptions-view colgroup {
            display: none;
        }
        .ant-descriptions-view tbody {
            display: block;
        }
        .ant-descriptions-row {
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid #f0f0f0;
        }
        .ant-descriptions-row > th,
        .ant-descriptions-row > td {
            display: block;
            width: 100% !important;
            max-width: 100% !important;
        }
        .ant-descriptions-item-label {
            background-color: #fafafa;
            font-weight: 600;
            padding: 8px 12px !important;
            border-right: none !important;
        }
        .ant-descriptions-item-content {
            padding: 8px 12px !important;
            word-break: break-word;
        }
    }
`;
export const SubCompanyFilterRow = styled(Row)`
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }
`;
export const SubCompanyFilterSpace = styled(Space)`
    @media (max-width: 768px) {
        flex-wrap: wrap;
        width: 100%;
        .ant-space-item {
            width: 100%;
        }
        .ant-select {
            width: 100% !important;
        }
        .ant-input-search {
            width: 100% !important;
        }
    }
`;
export const SubCompanyActionRow = styled(Row)`
    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;
        .ant-btn {
            width: 100%;
        }
        .ant-upload {
            width: 100%;
        }
    }
`;
